[].slice.call(document.querySelectorAll('section.services .bg-wrapper, #sidebar .bg-wrapper:not(.video-link), #sidebar .video-link a, .videos-container .video-link a')).forEach(function(card) {
	var container = body.classList.contains('video-library') ? card.closest('.container1') : document.querySelector('section.services, #sidebar');
		cardDown = new Waypoint({
			element: card,
			handler: function(direction) {
				if(direction == 'down')
					setCurrentCard(container, card);
			},
			offset: '50%'
		}),
		cardUp = new Waypoint({
			element: card,
			handler: function(direction) {
				if(direction == 'up')
					setCurrentCard(container, card);
			},
			offset: '25%'
		});
});

function setCurrentCard(container, card) {
	if(checkWidth(768)) {
		var current = container.querySelector('.current');

		if(current && current != card)
			current.classList.remove('current');

		if(card)
			card.classList.add('current');
	}
}